import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IExtractEncryptionStats } from '../../types/extractEncryption/IExtractEncryptionStats';

export interface IGetExtractEncryptionStatsParams {
  id: string;
}

export interface IGetExtractEncryptionStatsResult {
    counts: IExtractEncryptionStats;
}

export class GetExtractEncryptionStatsRequest extends Request<IGetExtractEncryptionStatsParams, IGetExtractEncryptionStatsResult> {
  constructor(params: IGetExtractEncryptionStatsParams) {
    super('getExtractEncryptionStats', params);
  }
}
